
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const ServicesFooter = () => {
  // Scrolls smoothly to the contact section
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const navbarHeight = 56;
      const offsetTop = contactSection.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <div className="mt-8 text-center">
      <Button 
        onClick={scrollToContact}
        className="bg-[#FF6B6B] hover:bg-[#ff5252] text-white font-medium py-2 px-6 rounded-lg transition-all"
      >
        Get Started
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};

export default ServicesFooter;
